import { create } from 'jss'
import jssPluginGlobal from 'jss-plugin-global'
import jssNested from 'jss-plugin-nested'
import jssCamelCase from 'jss-plugin-camel-case'
import jssVendorPrefixer from 'jss-plugin-vendor-prefixer'

export default function CreateJssInstance() {
  const instance = create({
    plugins: [
      jssNested(),
      jssPluginGlobal(),
      jssCamelCase(),
      jssVendorPrefixer(),
    ]
  })
  return instance
}
